import React from 'react';

import { useMerchant } from '@contexts/admin/MerchantContext';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';
import InventoryMonitorsEdit from '@shared/inventory_monitors/InventoryMonitorsEdit';

import { inventoryMonitorService } from '@services/admin/inventoryMonitorService';
import { productService } from '@services/admin/productService';

export default function AdminInventoryMonitorNew() {
  const { currentMerchant } = useMerchant();
  const { inventoryTypes, loading } = useMerchantData();

  return (
    <InventoryMonitorsEdit
      inventoryMonitorService={inventoryMonitorService}
      productService={productService}
      inventoryTypes={inventoryTypes}
      inventoryMonitorId={undefined}
      merchantIdForCreate={currentMerchant?.id ?? null}
      merchantDataLoading={Boolean(loading)}
    />
  );
}
